/* eslint-disable no-underscore-dangle */
import helpers from '@/helpers/service';
import AxiosBase from './AxiosBase';

const isQA = process.env.VUE_APP_QA;
const authBaseURL = isQA ? '/auth-qa' : '/auth';

const axios = new AxiosBase();
/**
 * Authentication-related methods
 */
const AuthService = {
  loginUser(email, password) {
    return axios.post(`${authBaseURL}/login`, { email, password, withPermissions: true })
      .then(({ data }) => data)
      .catch(helpers._catch('An error occurred upon login'));
  },
  forgotPassword(email) {
    return axios.post(`${authBaseURL}/forgot-password`, { email, withPermissions: true })
      .then(({ data }) => data)
      .catch(helpers._catch('An error occurred upon submission'));
  },
  forgotPasswordchange(key, password) {
    return axios.post(`${authBaseURL}/forgot-password/change`, { key, password, withPermissions: true })
      .then(({ data }) => data)
      .catch(helpers._catch('An error occurred upon submission'));
  },
  validateForgotPasswordkey(key) {
    return axios.post(`${authBaseURL}/forgot-password/validate-key`, { key, withPermissions: true })
      .then(({ data }) => data)
      .catch(helpers._catch('An error occurred upon submission'));
  },
};

export default AuthService;
